<template>
  <div class="contentContainer">
    <div class="formBox">
      <div class="title">{{ $t("forcePwdChange.title") }}</div>
      <div class="reasonTitle">
        {{
          userPwdFlag.userFirstLogin
            ? $t("forcePwdChange.userFirstLogin")
            : $t("forcePwdChange.passwordModifyExpires")
        }}
      </div>
      <div class="form">
        <el-form
          ref="changePasswordForm"
          :rules="changePasswordRules"
          :model="changePasswordForm"
        >
          <el-form-item :label="$t('forcePwdChange.oldPwd')" prop="oldpass">
            <pwdInput
              v-model="changePasswordForm.oldpass"
              :maxlength="256"
            ></pwdInput>
          </el-form-item>
          <el-form-item :label="$t('forcePwdChange.newPwd')" prop="pass" class="pwd-item">
            <pwdInput
              v-model="changePasswordForm.pass"
              :maxlength="pwdConfig.pwdLength"
            ></pwdInput>
            <password
              v-model="changePasswordForm.pass"
              :strength-meter-only="true"
            />
          </el-form-item>
          <el-form-item :label="$t('forcePwdChange.makesure')" prop="checkpass">
            <pwdInput
              v-model="changePasswordForm.checkpass"
              :maxlength="pwdConfig.pwdLength"
            ></pwdInput>
          </el-form-item>
        </el-form>
        <div slot="footer" class="footerBtnBox">
          <el-button size="small" @click="resetPwd()">{{
            $t("button.reset")
          }}</el-button>
          <el-button size="small" type="primary" @click="changePassword()">{{
            $t("button.confirm")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/utils.js";
import Password from "vue-password-strength-meter";
import md5 from "js-md5";
import pwdInput from "@/components/pwdInput.vue";
import { clearLocalStorage } from "@/utils/lsClear";
export default {
  components: { Password, pwdInput },
  data() {
    let passwordRule = (rule, value, callback) => {
      var regex = new RegExp(this.pwdConfig.pwdRule);
      if (regex.test(value) == false) {
        callback(
          new Error(this.$t("pwdStrengthRule." + this.pwdConfig.pwdStrength))
        );
      } else if (value == this.changePasswordForm.oldpass) {
        callback(new Error(this.$t("forcePwdChangePromptMessage.samePass")));
      } else {
        this.$refs.changePasswordForm.validateField("checkpass");
        callback();
      }
    };
    let checkPasswordRule = (rule, value, callback) => {
      if (!isEmpty(value)) {
        if (value == this.changePasswordForm.pass) {
          callback();
        } else {
          callback(
            new Error(this.$t("forcePwdChangePromptMessage.diffPassword"))
          );
        }
      } else {
        callback(new Error(" "));
      }
    };
    return {
      pwdConfig: {
        pwdRule: "",
        pwdLength: "18",
        pwdStrength: "",
      },
      userPwdFlag: {
        userFirstLogin: false,
        passwordModifyExpires: false,
      },
      changePasswordForm: {
        oldpass: "",
        pass: "",
        checkpass: "",
      },
      changePasswordRules: {
        oldpass: [{ required: true, message: " ", trigger: "blur" }],
        pass: [{ required: true, validator: passwordRule, trigger: "blur" }],
        checkpass: [
          { required: true, validator: checkPasswordRule, trigger: "blur" },
        ],
      },
      userId: "",
      username: "",
    };
  },
  created() {
    this.getPwdRule();
    this.getUserInfo();
    if (!isEmpty(this.$route.params)) {
      this.userPwdFlag = this.$route.params;
      localStorage.setItem("as-pwdFlag", JSON.stringify(this.$route.params));
    } else {
      let pwdConfig = localStorage.getItem("as-pwdFlag")
        ? JSON.parse(localStorage.getItem("as-pwdFlag"))
        : {};
      if (!isEmpty(pwdConfig)) {
        this.userPwdFlag = pwdConfig;
      }
    }
  },
  methods: {
    getPwdRule() {
      this.$httpList.getPwdStrength().then((res) => {
        if (res.resultCode == 1001) {
          this.pwdConfig.pwdRule = res.data.rule;
          this.pwdConfig.pwdStrength = res.data.type;
          this.pwdConfig.pwdLength = res.data.maxLength;
        }
      });
    },
    async checkUserPassword(oldPwd){
      try {
        const res = await this.$httpList.checkUserPassword(oldPwd);
        if (res.resultCode == 1001) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async changePassword() {
      const valid = await new Promise((resolve) => {
        this.$refs.changePasswordForm.validate((valid) => resolve(valid));
      });
      if (!valid) {
        return;
      }
      const oldPwd = md5(this.changePasswordForm.oldpass + this.username).toUpperCase();
      const checkResult = await this.checkUserPassword(oldPwd);
      if (!checkResult) {
        return;
      }
      let submitInfo = {
        id: this.userId,
        newPwd: md5(
          this.changePasswordForm.pass + this.username
        ).toUpperCase(),
        oldPwd,
      };
      await new Promise((resolve) => {
        this.$confirm(this.$t("forcePwdChangePromptMessage.confirmChangePwd"), {
          confirmButtonText: this.$t("button.confirm"),
          cancelButtonText: this.$t("button.cancel"),
          closeOnClickModal: false,
        })
        .then(() => {
          this.$httpList.updateUserOwnPwd(submitInfo).then((res) => {
            if (res.resultCode == 1001) {
              this.$notify({
                message: `${this.$t("forcePwdChangePromptMessage.changePassword")}`,
                type: "success",
              });
              // 修改密码直接退出
              localStorage.removeItem("as-pwdFlag");
              // this.$actions.setGlobalState({ logout: true });
              clearLocalStorage();
              // 重定向至登录页面
              let currentUrl = window.location.href;
              let position = currentUrl.indexOf("/#");
              let loginUrl = currentUrl.substring(0, position);
              window.location.href = loginUrl;
            }
            resolve(res);
          });
        })
        .catch(() => {
          resolve(false);
        });
      });
    },
    getUserInfo() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getUserInfo()
          .then((res) => {
            if (res.resultCode == 1001) {
              this.userId = res.data.id;
              this.username = res.data.username;
            }
            resolve(res);
          })
          .catch((res) => {
            reject(res);
          });
      });
    },
    resetPwd() {
      this.changePasswordForm = {
        oldpass: "",
        pass: "",
        checkpass: "",
      };
      this.$nextTick(() => {
        this.$refs.changePasswordForm.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contentContainer {
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-image: url('../assets/login/pwd_bg.png');
  .formBox {
    width:500px;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 0px rgba(187, 191, 196, 0.5);
    border:1px solid rgba(187, 191, 196, 0.5);
    border-radius: 10px;
    background:#fff;
    // padding: 100px;
    .title {
      margin-top: 20px;
      text-align: center;
      font-weight: 600;
      font-size:16px;
      color:#333333;
    }
    .reasonTitle {
      margin-top: 15px;
      text-align: center;
      font-size: 14px;
    }
    .form {
      padding: 2vw;
    }
    .footerBtnBox {
      display: flex;
      justify-content: space-between;
      .el-button {
        border-radius: 8px !important;
      }
    }
  }
  .pwd-item{
    ::v-deep.el-form-item__error{
      margin-top:-20px;
    }
  }
}
</style>
